export default "__VITE_ASSET__BLM_e2KH__"